import { PhoneInput } from './styles'

export default PhoneInput
